import * as React from 'react';

function User5Active(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={45}
      height={46}
      data-type="active"
      viewBox="0 0 45 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22.5.625C10.02.625 0 10.732 0 23.125c0 12.48 10.02 22.5 22.5 22.5 12.393 0 22.5-10.02 22.5-22.5C45 10.732 34.893.625 22.5.625zm0 11.25c3.428 0 6.328 2.9 6.328 6.328 0 3.516-2.9 6.328-6.328 6.328a6.302 6.302 0 01-6.328-6.328c0-3.428 2.812-6.328 6.328-6.328zM22.5 40c-4.658 0-8.877-1.846-11.953-4.922 1.406-3.691 4.922-6.328 9.14-6.328h5.625c4.131 0 7.647 2.637 9.053 6.328A16.75 16.75 0 0122.5 40z"
        fill="url(#prefix__paint0_linear_14321_31657)"
      />
      <defs>
        <linearGradient
          id="prefix__paint0_linear_14321_31657"
          x1={0.469}
          y1={45.531}
          x2={45}
          y2={1}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FFBF17" />
          <stop offset={1} stopColor="#F2E2B8" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default User5Active;
